/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var Ladda = require('ladda');
var Syphon = require('backbone.syphon');
var Radio = require('backbone.radio');

var momentUtil = require('common/util/momentUtil');
var BreadcrumbView = require('common/views/BreadcrumbView');

var SubmitEntityTracking = require('../services/SubmitEntityTracking');
var DepKeyThirdPartyVendorFormView = require('./DepKeyThirdPartyVendorFormView');

var tmplDepKeyThirdPartyVendorNewView = require('../templates/DepKeyThirdPartyVendorNewView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplDepKeyThirdPartyVendorNewView,

  className: 'dep-entity-new-key-third-party-vendor-form-view container-fluid',

  ui: {
    breadcrumb: '.breadcrumb-container',
    keyThirdPartyVendorFormContainer: '.new-key-third-party-vendor-container',
    submit: '.btn-submit'
  },

  regions: {
    breadcrumb: '@ui.breadcrumb',
    keyThirdPartyVendorFormContainer: '@ui.keyThirdPartyVendorFormContainer'
  },

  events: {
    'click @ui.submit': 'onClickSubmit'
  },

  onBeforeShow: function() {
    var entityId = this.model.get('entityId');
    var entityName = this.model.get('entityName');

    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: [
          {
            link: '#dep/dashboard',
            text: 'Home'
          },
          {
            link: '#dep/entity/' + entityId + '/dashboard',
            text: entityName
          },
          {
            text: 'New Key Third-Party Vendor'
          }
        ]
      })
    );

    this.trackingForm = new DepKeyThirdPartyVendorFormView({
      model: new Backbone.Model({
        entityTypeId: this.model.get('entityTypeId'),
        entityCategoryId: this.model.get('entityCategoryId'),
        trackingLookups: this.model.get('trackingLookups') || {}
      })
    });

    this.showChildView('keyThirdPartyVendorFormContainer', this.trackingForm);
  },

  onClickSubmit: function(e) {
    e.preventDefault();

    var laddaContext = Ladda.create(e.currentTarget);
    this.trackingForm.validate().done(
      function() {
        laddaContext.start();

        var entityId = this.model.get('entityId');
        var entityCategoryId = this.model.get('entityCategoryId');

        var formData = Syphon.serialize(this);
        formData.entityId = entityId;

        formData.enteredDate = momentUtil.formatStr(formData.enteredDate, momentUtil.defaultOutboundDateConfig);
        formData.asOfDate = momentUtil.formatStr(formData.asOfDate, momentUtil.defaultOutboundDateConfig);
        formData.examStartDate = momentUtil.formatStr(formData.examStartDate, momentUtil.defaultOutboundDateConfig);

        switch (entityCategoryId) {
          case '1':
            formData.trackingTypeId = '5';
            break;
          case '2':
            formData.trackingTypeId = '14';
            break;
          case '3':
            formData.trackingTypeId = '22';
            break;
        }

        SubmitEntityTracking(formData)
          .done(function(trackingId) {
            Radio.channel('navigate').trigger('show:int:dp:key-third-party-vendor', entityId, trackingId);
          })
          .fail(function(err) {
            laddaContext.stop();
          });
      }.bind(this)
    );
  }
});
